<template>
    <div class="card item-card">
        <a  v-if="work_card.external_link"
            :href="work_card.external_link" class="external-icon" title="Ir al sitio" target="_blank">
            <img src="@/assets/images/svg-icons/external-link.svg" alt="Link">
        </a>
        <div class="card-image">
            <div class="bg"></div>
            <div
                :style="`background-image: url(${require(`@/assets/images/works/${work_card.image}`)})`" 
                class="image"></div>
            <!-- <img :src="require(`@/assets/images/works/${work_card.image}`)"> -->
            <span class="card-title" v-html="work_card.title"></span>
        </div>
        <div class="card-content">
            <p v-html="work_card.description"></p>
        </div>
        <div class="card-action">
            <div class="tools">                
                <img :src="image" v-for="(image, index) in images" :key="index" />
            </div>
            <!-- <a href="#" class="blue-text">{{ work_card.link.to || 'Ver más' }}</a> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['work_card'],
    data() {
        return {

        }
    },
    computed: {
        images() {
            // `
            let images = [],
                tools = {
                    html_css: require(`@/assets/images/about-me/skills/html-css.svg`),
                    vue: require(`@/assets/images/about-me/skills/vuejs.svg`),
                    lumen: require(`@/assets/images/about-me/skills/lumen.svg`),
                    sass: require(`@/assets/images/about-me/skills/sass.svg`),
                    js: require(`@/assets/images/about-me/skills/javascript.svg`),
                    git: require(`@/assets/images/about-me/skills/git.svg`),
                    my_sql: require(`@/assets/images/about-me/skills/mysql.svg`),
                    wordpress: require(`@/assets/images/about-me/skills/wordpress.svg`)
                };

            for (const key in this.work_card.tools) {
                for (const key2 in tools) {
                    if (this.work_card.tools[key] == key2) {
                        images.push(tools[key2]);
                    }
                }
            }

            return images;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import '@/assets/css/_mixins.scss';

.item-card { 
    margin-bottom: 2rem;
    
    .external-icon {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 4;
        border-radius: 0px 0px 0px 5px;
        background-color: rgba(255,255,255, 1);
        box-shadow: 0px 0px 2px 0px #fff;
        padding: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
        @include transition(opacity 0.3s);

        &:hover {
            opacity: 0.8;
        }
    }

    .card-image {
        .image {
            height: 230px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
        }

        .bg {
            content: '' ;
            z-index: 2;
            position: absolute ;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0,0,0,0.7);
            @include transition(all 0.3s);
        }
        
        span { 
            font-size: 1.3rem;
            text-align: center;
            z-index: 3; 
            top: 0;
            bottom: 0;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            @include transition(all 0.1s);
        }

        &:hover {
            .bg { background-color: transparent }
            span { visibility: hidden }
        }

        @media (min-width: 1024px) {
            .image {
                height: 300px
            }
            span { font-size: 1.5rem }
        }
        @media (min-width: 1200px) {
            .image { height: 250px  }
        }
        @media (min-width: 1600px) {
            .image { height: 280px  }
            span { font-size: 1.6rem }
        }
    }

    .card-content {
        p { min-height: 100px }

        @media (min-width: 1024px) {
            p { min-height: 80px }
        }
    }

    .card-action {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .tools {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 1.5rem;

            img { 
                width: 30px;
                margin-right: 8px;

                &:last-child { margin-right: 0px }
            }
        }

        a {
            margin-right: 0px !important;

            &:hover {
                color: $main-black-2 !important 
            }
        }

        @media (min-width: 1024px) {
            flex-direction: row;
            justify-content: space-between;

            .tools { 
                width: 100%;
                // width: 70%;
                // justify-content: flex-start;
                margin-bottom: 0px;
            }

            a { width: 30%; text-align: right }
        }
    }
    @media (min-width: 760px) {
        width: 47% 
    }

    @media (min-width: 1200px) {
        width: 30%;
        margin-right: 5%;
        flex-direction: row;

        &:nth-child(3n) {
            margin-right: 0px
        }
    }
}
</style>